import React, { useState } from "react";
import { Alert, Button, Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import useAxiosData from "~/shared/use-axios-data";
import axios from "axios";
import AutoSelectInput from "~/shared/form/AutoSelectInput";
import DataTable from "~/shared/DataTable";
import { localeFormatDate } from "~/shared/utils";
import AlertBox from "~/shared/AlertBox";

export default function ViewNotifications() {
    const history = useHistory();

    const [openNotification, setOpenNotification] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [notifications, status, setNotifications] = useAxiosData(() => axios.get("notifications"), []);
    const [allPrograms] = useAxiosData(() => axios.get("programs"), []);
    const allProgramOptions = [null, ...allPrograms];

    function getNotificationToField({ roles, programs }) {
        if (roles.length === 1) {
            if (roles[0] === "STAFF") {
                return "All Staff";
            }

            if (roles[0] === "FAMILY") {
                if (programs.length === allProgramOptions.length && allProgramOptions.every(p => programs.some(program => program?._id === p?._id))) {
                    return "All Families";
                }

                return `Families in: ${programs.map(p => p?.name ?? "(Not in Program)").join(", ")}`;
            }
        }

        return `${getNotificationToField({ roles: ["STAFF"], programs })}; ${getNotificationToField({ roles: ["FAMILY"], programs })}`;
    }

    function editAndResend(e) {
        e.preventDefault();
        openNotification.roles = openNotification.roles.map(r => r[0] + r.substring(1).toLowerCase()).join(" & ");
        openNotification.types = openNotification.types.length === 1 && openNotification.types[0] === "Email" ? "Email" : openNotification.types.length === 2 ? "Email & SMS" : "SMS";
        openNotification.programs = openNotification.programs.filter(p => p === null || allPrograms.some(({name}) => p.name === name)).map(p => p?.name ?? "(Not in Program)");
        history.push({ pathname: "/admin/send-notification", state: openNotification });
    }

    async function updateNotifications(filter) {
        if (filter) {
            filter = filter.substring(3);
        }

        setNotifications((await axios.get(`notifications/${filter}`)).data);
    }

    function getNotificationActions(notification) {
        return <Button variant="link" onClick={() => (setOpenNotification(notification), setShowModal(true))}>View</Button>;
    }

    return (
        <section>
            <AutoSelectInput className="mt-3 mb-4" placeholder="To All Roles" update={updateNotifications} options={["To Family", "To Staff"]} />

            <DataTable data={notifications} paginate pageSizes={[5, 10, 20, 50]} defaultPageSize={10} loading={status === "loading"}>
                <DataTable.Column id="title" sortable>Title</DataTable.Column>
                <DataTable.Column showAt="sm" id="types" format={types => types.join(", ")} sortable sortBy={v => v.join()}>Method(s)</DataTable.Column>
                <DataTable.Column id="sender" sortable>Sent By</DataTable.Column>
                <DataTable.Column showAt="lg" value={getNotificationToField}>To</DataTable.Column>
                <DataTable.Column id="createdAt" format={localeFormatDate} sortable>Sent At</DataTable.Column>
                <DataTable.Column value={getNotificationActions}>Actions</DataTable.Column>
                <DataTable.Message condition={status === "error"}>
                    <AlertBox type="error">An unknown error occurred. Please try again later.</AlertBox>
                </DataTable.Message>
                <DataTable.Message condition={notifications.length === 0}>
                    <AlertBox type="info">No notifications found.</AlertBox>
                </DataTable.Message>
            </DataTable>

            {openNotification && <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{openNotification.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-start">
                    <p>
                        <b>Method(s):</b> {openNotification.types.join(", ")} <br />
                        <b>Sent By:</b> {openNotification.sender} <br />
                        <b>To:</b> {getNotificationToField(openNotification)} <br />
                        <b>Sent At:</b> {new Date(openNotification.createdAt).toLocaleString()}
                    </p>
                    <p>{openNotification.message}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" as="a" href="/admin/send-notification" onClick={editAndResend}>Edit & Resend</Button>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
                </Modal.Footer>
            </Modal>}
        </section>
    );
}
